/**
 * Errors caused by ad blockers, offline users, private browsing, or missing optional
 * server config — not application bugs. Call sites should degrade gracefully and
 * avoid reporting these to Sentry.
 */
export function getErrorMessageFromUnknown(error: unknown): string {
  if (error instanceof Error) {
    return error.message;
  }
  if (typeof error === 'string') {
    return error;
  }
  try {
    return JSON.stringify(error);
  } catch {
    return String(error);
  }
}

function normalizeErrorMessageForMatch(message: string): string {
  return message.replace(/^[A-Za-z]+Error:\s*/, '').trim();
}

export function isExpectedEnvironmentErrorMessage(message: string): boolean {
  const normalized = normalizeErrorMessageForMatch(message.trim());
  if (!normalized) {
    return false;
  }

  if (normalized.includes('Unreachable hosts')) {
    return true;
  }
  if (normalized.includes('alg.li/support-unreachable-hosts')) {
    return true;
  }

  if (normalized === 'Failed to fetch' || normalized.includes('Failed to fetch dynamically imported module')) {
    return true;
  }
  if (normalized === 'fetch failed') {
    return true;
  }
  if (normalized === 'Load failed') {
    return true;
  }
  if (normalized === 'NetworkError when attempting to fetch resource.') {
    return true;
  }
  if (normalized.includes('Network request failed')) {
    return true;
  }

  if (normalized.includes('Terrain and hillshade are disabled')) {
    return true;
  }
  if (normalized.includes('Canvas2D limitations when fingerprinting protection')) {
    return true;
  }

  if (normalized === 'OPENAI_API_KEY is not set') {
    return true;
  }

  return false;
}

export function isExpectedEnvironmentError(error: unknown): boolean {
  return isExpectedEnvironmentErrorMessage(getErrorMessageFromUnknown(error));
}
